// src/components/EventList.js
import React from "react";
import { Box, List, ListItem, ListItemText, Divider, Button, Typography } from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import WarningIcon from "@mui/icons-material/Warning";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import HomeIcon from "@mui/icons-material/Home";

const dummyEvents = [
  { id: 1, type: "medical", title: "Medical Alert from Client A", time: "10:00 AM", active: false },
  { id: 2, type: "panic", title: "Panic Alert from Client B", time: "10:05 AM", active: true },
  {
    id: 3,
    type: "car_tracking",
    title: "Car Tracking Alert from Client C",
    time: "10:10 AM",
    active: false,
  },
  {
    id: 4,
    type: "home_security",
    title: "Home Security Alert from Client D",
    time: "10:15 AM",
    active: false,
  },
  { id: 5, type: "panic", title: "Panic Alert from Client E", time: "10:20 AM", active: true },
];

function getIconForType(type) {
  switch (type) {
    case "medical":
      return <LocalHospitalIcon sx={{ color: "#1976d2" }} />;
    case "panic":
      return <WarningIcon sx={{ color: "#E63572" }} />;
    case "car_tracking":
      return <DirectionsCarIcon sx={{ color: "#4caf50" }} />;
    case "home_security":
      return <HomeIcon sx={{ color: "#ff9800" }} />;
    default:
      return null;
  }
}

function EventList() {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "10px",
        p: 2,
        m: 2,
        maxHeight: 500,
        overflowY: "auto",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Recent Events
      </Typography>
      <List>
        {dummyEvents.map((event, index) => (
          <Box key={event.id} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Box sx={{ mr: 1 }}>{getIconForType(event.type)}</Box>
            <Box sx={{ flexGrow: 1 }}>
              <ListItemText
                primary={
                  <>
                    {event.title}{" "}
                    {event.active && (
                      <Typography
                        component="span"
                        sx={{
                          backgroundColor: "#E63572",
                          color: "#fff",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          px: 0.5,
                          ml: 1,
                          fontSize: "0.75rem",
                        }}
                      >
                        ACTIVE
                      </Typography>
                    )}
                  </>
                }
                secondary={event.time}
              />
            </Box>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#E63572",
                color: "#fff",
                borderRadius: "4px",
                "&:hover": { backgroundColor: "#d32f2f" },
              }}
            >
              View
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}

export default EventList;
